export default "__VITE_ASSET__DjzSlRD___"